module.exports = __webpack_public_path__ + "img/hongdouyimi.c3dda9f1.jpg";